"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M8.816 14.696A3.179 3.179 0 0 1 12 11.516a3.178 3.178 0 0 1 3.184 3.18v3.914c0 .135-.11.244-.245.244H9.06a.245.245 0 0 1-.245-.244v-3.914ZM12 12.984c-.942 0-1.714.771-1.714 1.712v2.69h3.428v-2.69A1.72 1.72 0 0 0 12 12.984Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11.257 1.26c.215-.175.41-.26.667-.26h.149c.24 0 .515.15.665.267l.004.003 10.816 8.728c.283.233.442.576.442.942v10.35c0 1.49-1.192 2.71-2.655 2.71H2.655C1.183 24 0 22.79 0 21.3V10.95c0-.366.159-.71.442-.942l.001-.002 10.814-8.745ZM12 2.568 1.47 11.095v10.156c0 .692.551 1.252 1.224 1.252h18.612c.673 0 1.225-.56 1.225-1.252V11.056L12 2.566Z",
    clipRule: "evenodd"
  })]
});